import { useLocalStorage } from "@coffee/ui/hooks";
import styled from "@emotion/styled";
import { TransparentButton } from "@financial-advisory/ui/components/buttons";
import {
  ChatContainer,
  useChatMessageState,
} from "@financial-advisory/ui/components/chat";
import {
  IconLayoutSidebarRightCollapse,
  IconLayoutSidebarRightExpand,
  IconRefresh,
} from "@tabler/icons-react";
import * as colors from "tailwindcss/colors";
import { Heading } from "@unlikelyai-magic/ui/typography";

const SidebarContainer = styled.div`
  position: fixed;
  top: 0;
  right: 1rem;
  padding: 1rem;
  height: 100vh;
`;

const Sidebar = styled.div`
  display: flex;
  flex-direction: column;
  width: 30rem;
  height: 100%;
  border: 1px solid ${colors.gray[100]};
  box-shadow: 0 0 0.5rem 0 rgba(0, 0, 0, 0.1);
  border-radius: 1.5rem;
  background-color: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(1.5rem);
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: rgba(255, 255, 255, 1);
  }
`;

const SidebarHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 1.5rem;
`;

const ChatBoxContainer = styled.div`
  display: flex;
  flex: 1 1 0;
  min-height: 0;
  justify-content: center;
`;

const ChatBox = styled(ChatContainer)`
  display: flex;
  width: 100%;
  padding: 1rem;
`;

const SidebarContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
`;

const STORAGE_KEY = "graph-sidebar-is-open";

export const GraphSidebar = () => {
  const [isOpen, setIsOpen] = useLocalStorage<boolean>(STORAGE_KEY, true);
  const { reset } = useChatMessageState();

  return (
    <SidebarContainer>
      {isOpen ? (
        <Sidebar>
          <SidebarHeader>
            <Heading level="h3">Conversation</Heading>
            <div style={{ display: "flex", gap: "0.5rem" }}>
              <TransparentButton
                onClick={reset}
                icon={<IconRefresh className="w-5 h-5" />}
              />
              <TransparentButton
                onClick={() => setIsOpen(false)}
                icon={<IconLayoutSidebarRightCollapse className="w-6 h-6" />}
              />
            </div>
          </SidebarHeader>
          <SidebarContent>
            <ChatBoxContainer>
              <ChatBox />
            </ChatBoxContainer>
          </SidebarContent>
        </Sidebar>
      ) : (
        <TransparentButton
          onClick={() => setIsOpen(true)}
          size="xl"
          icon={<IconLayoutSidebarRightExpand className="w-6 h-6" />}
        />
      )}
    </SidebarContainer>
  );
};
